import { render, staticRenderFns } from "./seeProject.vue?vue&type=template&id=28f6a796&scoped=true&"
import script from "./seeProject.vue?vue&type=script&lang=js&"
export * from "./seeProject.vue?vue&type=script&lang=js&"
import style0 from "./seeProject.vue?vue&type=style&index=0&id=28f6a796&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6a796",
  null
  
)

export default component.exports